import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';
import type { CompanySettings } from '~/shared/data-contract/company-settings';

import { useGlobalPermissions } from '../../app/query-hooks/global-permissions';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { companySettingsKeys } from './query-keys';

export const useCompanySettings = (): UseQueryResult<CompanySettings, Error> => {
    const { fetchCompanySettings } = useApplicationFetchers();
    const { applicationState } = useApplicationContext();
    const { data: globalPermissions } = useGlobalPermissions();
    const isUserProfileComplete = applicationState.myUserProfile.mapOr(false, (profile) => profile.exists === true);

    return useQuery({
        enabled: isUserProfileComplete && globalPermissions?.canGetCompanySetting === true,
        queryFn: async () => {
            const result = await fetchCompanySettings();

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: companySettingsKeys.companySettings(),
        throwOnError: false,
    });
};
